module.exports = __webpack_public_path__ + "static/media/substr.fa9ec169.svg";